import React, { useCallback, useRef } from 'react';
import { Text } from '@goodfynd/ui';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

import type { InputRadioGroupControlProps } from '../types';

import { StyledLabel } from './styles';
export default function InputRadioGroupControl<T = string>({
  defaultValue,
  label,
  onChange,
  options,
  showLabel = true,
  value,
}: Omit<InputRadioGroupControlProps<T>, 'control'>) {
  const selectedOption = useRef(defaultValue || null);
  const renderOptions = useCallback(() => {
    return options.map((option) => (
      <FormControlLabel
        control={<Radio />}
        key={typeof option.label === 'string' ? option.label : option.value}
        value={option.value}
        label={
          <StyledLabel>
            <Text as="body1">{option.label}</Text>
            <Text>{option.labelRight}</Text>
          </StyledLabel>
        }
      />
    ));
  }, [options]);

  // defaultValue && alert(defaultValue);
  return (
    <FormControl fullWidth variant="outlined">
      {showLabel &&
        (typeof label === 'string' ? (
          <FormLabel component="legend">{label}</FormLabel>
        ) : (
          label
        ))}

      <RadioGroup
        {...(value !== undefined
          ? { value }
          : { defaultValue: selectedOption?.current })}
        onChange={onChange}
      >
        {renderOptions()}
      </RadioGroup>
    </FormControl>
  );
}
